var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sharing-metric"},[_c('div',{staticClass:"share-number baColorDeepBlueText--text"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"share-text baColorPrimaryText--text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }